export default {
  title: 'orange',

  colors: {
    twitter: 'rgb(250, 97, 33)',
    darkhover: '#190A04',
    lighthover: '#322623',
  },
};